<template>
<!-- eslint-disable max-len -->
<span>
  <div class="game-error-wrapper">
    <div class="game-error">
      <div class="message">
        <p>Please check your internet connection.</p>
        <p>Then press restart to continue.</p>
      </div>
      <button class="btn" @click.prevent.stop="restart" v-focus>Restart</button>
    </div>
  </div>
</span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'startState'
    ])
  },
  methods: {
    restart() {
      // window.location.href = this.startState;
      window.location.href = '/';
    }
  }
};
</script>

<style lang="scss" scoped>
.game-error-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
.game-error {
  background-color: white;
  width: 800px;
  height: 440px;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 25px 20px 15px 20px;
}
.game-error .message {
  background-color: black;
  color: white;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  padding: 15px;
  flex: 1 1 auto;
  overflow: auto;
  margin-bottom: 10px;
}
.game-error button {
  width: 250px;
  font-size: 32px;
  flex: 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/GameError.vue